// src/hooks/useFetchState.js
import { useEffect, useState } from 'react';
import { api } from '../api';

export default function useFetchState() {
  const [state, setState] = useState({
    resources: [],
    containers: [],
    locations: [],
    availableResources: {},
    availableContainers: [],
    availableLocations: [],
  });

  const fetchState = async () => {
    try {
      const data = await api.fetchState();
      setState(data);
    } catch (err) {
      console.error('Error fetching state:', err);
    }
  };

  useEffect(() => {
    fetchState();
  }, []);

  return [state, fetchState, setState];
}